// src/pages/PasswordResetSuccess.jsx
import React from 'react'
// import { useNavigate } from 'react-router-dom'

const PasswordResetSuccessPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-green-100">
      <div className="bg-white p-8 rounded-lg shadow-md text-center">
        <h2 className="text-2xl font-semibold mb-4 text-green-700">¡Contraseña restablecida con éxito!</h2>
      </div>
    </div>
  )
}

export default PasswordResetSuccessPage
